import { expected } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { LoadingScreenSam } from '../../components/LoadingScreen/LoadingScreenSam.tsx';
import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AdjustmentsGridModule } from '../../modules/adjustmentsGrid/AdjustmentsGridModule.tsx';
import { PropertyComparisonGridSyncDriver } from '../OrderSync/PropertyComparisonGridSyncDriver.tsx';
import { useUnitRateModelsSyncDriver } from '../OrderSync/useUnitRateModelsSyncDriver.ts';

const AdjustmentsGridRouteElementInner = ({ orderId }: { orderId: string }) => {
  const { isPending } = useUnitRateModelsSyncDriver(orderId);

  if (isPending) return <LoadingScreenSam what="Unit Rates" fadeIn />;

  return (
    <ModuleContainer moduleID="adjustmentsGrid" compact>
      <AdjustmentsGridModule />
    </ModuleContainer>
  );
};

export const AdjustmentsGridRouteElement = () => {
  const orderId = expected(useParams().orderId);

  return (
    <PropertyComparisonGridSyncDriver orderID={orderId}>
      <AdjustmentsGridRouteElementInner orderId={orderId} />
    </PropertyComparisonGridSyncDriver>
  );
};
